module.exports = __webpack_public_path__ + "media/images/coin-fb265aab83d34f1aff6633fd03c552be.svg";